import { cloneDeep } from "lodash";
import { allDataSourcesOptions, allIncomeClassificators, allMeasureUnitsOptions, allPeriodicitiesOptions, allReportNamesOptions, allReportTypesOptions, allStatusOptions, allClassificationTypesOptions, allPaymentTypesOptions, allStatusOptionsExtended } from "../../common/baseOptions";
import { Classificator } from "../../common/types/Classificator";
import { Template } from "../../common/types/Template";
import { ReportRsFilterSettings } from "./settings/ReportRsFilterSettings";
import { ReportRsFilterOptions } from "./options/ReportRsFilterOptions";
import { Option } from "../../common/types/Option";
import { CertificateLevel, CertificateType, ClassificationType, PaymentType, StatusType } from "../../common/types/roots/fields";

export const reportRsExpensesClassificators: Classificator[] = [
    { key: 'gr',  active: false, selected: [] },
    { key: 'pgr', active: false, selected: [] },
    { key: 'abp', active: true, selected: [] },
    { key: 'prg', active: true, selected: [] },
    { key: 'ppr', active: false, selected: [] },
    { key: 'spf', active: false, selected: [] },
]
export const reportRsIncomesClassificators: Classificator[] = [
    { key: 'kat', active: true, selected: [] },
    { key: 'cls', active: true, selected: [] },
    { key: 'pcl', active: true, selected: [] },
    { key: 'spf', active: true, selected: [] }
]
export const reportRsCertificateLevelOptions: Option<CertificateLevel>[] = [
    { value: 'UO', label: 'УО', labelKk: 'УО', labelEn: 'AO' },
    { value: 'ABP', label: 'АБП', labelKk: 'ББӘ', labelEn: 'ABP' },
    { value: 'GU', label: 'ГУ', labelKk: 'ММ', labelEn: 'GU' }
]
export const reportRsCertificateTypeOptions: Option<CertificateType>[] = [
    { value: 'INTERNAL', label: 'Внутренняя', labelKk: 'Ішкі', labelEn: 'Internal' },
    { value: 'MOVEMENT', label: 'Передвижка', labelKk: 'Жылжыту', labelEn: 'Movement' },
    { value: 'ADJUSTMENT', label: 'Корректировка', labelKk: 'Түзету', labelEn: 'Adjustment' },
    { value: 'CLARIFICATION', label: 'Уточнение', labelKk: 'Нақтылау', labelEn: 'Clarification' }
]

const reportRsClassificationTypeValues = [
    "INCOMES",
    "EXPENSES",
    "MIXED"
]
export const reportRsClassificationTypeOptions: Option<ClassificationType>[] = allClassificationTypesOptions.filter(
    o => reportRsClassificationTypeValues.includes(o.value)
)


// Нужна как временная затычка (При созданий нового берутся пустые настройки)
const tempSettings: ReportRsFilterSettings = {
    // Base:
    reportName: 'RS',
    reportType: 'REGULATED',
    classificationType: 'INCOMES_OR_EXPENSES',
    dataSource: 'LOADER',
    periodicity: 'PERIOD',
    // Custom:
    period: { from: '', to: '' },
    region: '',
    certificateLevel: 'ABP',
    paymentType: 'OBLIGATIONS',
    certificateTypes: [],
    statuses: [],
    incomes: [],
    expenses: [],
    measureUnit: 'MILLION',
    roundUpTo: null,
    isTree: true,
    gus: [],
}

export const reportRsBaseTemplate: Template = {
    id: null,
    name: 'Реестр справок о внесении изменений',
    excelName: null,
    description: null,
    category: '55',
    regions: [],
    userId: '',
    filterSettings: tempSettings
}

export const reportRsFilterOptions: ReportRsFilterOptions = {
    // Base:
    key: 'RS',
    reportNames: cloneDeep(allReportNamesOptions),
    reportTypes: cloneDeep(allReportTypesOptions),
    classificationTypes: cloneDeep(reportRsClassificationTypeOptions),
    dataSources: cloneDeep(allDataSourcesOptions),
    periodicities: cloneDeep(allPeriodicitiesOptions),
    // Custom:
    measureUnits: cloneDeep(allMeasureUnitsOptions),
    regions: [], // Загружается с бэка
    statuses: cloneDeep(allStatusOptionsExtended),
    paymentTypes: cloneDeep(allPaymentTypesOptions),
    certificateLevels: cloneDeep(reportRsCertificateLevelOptions),
    certificateTypes: cloneDeep(reportRsCertificateTypeOptions),
    incomes: cloneDeep(reportRsIncomesClassificators),
    expenses: cloneDeep(reportRsExpensesClassificators)
}
